import { useHead } from '@unhead/react'

interface SEOProps {
  title: string
  description: string
  path: string
  image?: string
  noindex?: boolean
}

const SITE_URL = 'https://www.heartcanvas.ch'
const DEFAULT_OG_IMAGE = 'https://static.lumi.new/material/8a/8ad067509a43409e627c46ae2979d521.png'

function SEO({ title, description, path, image = DEFAULT_OG_IMAGE, noindex = false }: SEOProps) {
  const url = `${SITE_URL}${path}`

  useHead({
    title,
    meta: [
      { name: 'description', content: description },
      { name: 'robots', content: noindex ? 'noindex, nofollow' : 'index, follow' },
      { property: 'og:title', content: title },
      { property: 'og:description', content: description },
      { property: 'og:url', content: url },
      { property: 'og:image', content: image },
      { property: 'og:type', content: 'website' },
      { property: 'og:locale', content: 'fr_CH' },
      { property: 'og:site_name', content: 'HeartCanvas' },
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: title },
      { name: 'twitter:description', content: description },
      { name: 'twitter:image', content: image },
    ],
    link: [
      { rel: 'canonical', href: url },
    ],
  })

  return null
}

export default SEO
